export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: "clientName",
                label: '客户名称',
                type: "input",
            },
        ],
        searchdata: {
            clientName: "",
        },
        headData: [
            {
                title: "客户名称",
                prop: "clientName",
                issort: true,
                width: 100
            },
            {
                title: "key",
                prop: "apiKey",
                issort: true,
                width: 100
            },
            {
                title: "secret",
                prop: "secret",
                issort: true,
                width: 100
            },
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        },
    }
    return obj
}
